<template>
  <div class="app-container">
    <list ref="list">
    </list>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/website/msg/list";

export default {
  name: "msg",
  mixins: [curdMixins],
  components: {
    list
  },
  methods: {
  },
};
</script>